import React, { Fragment } from 'react'
import MatrixReplyPreview from 'matrix-react-sdk/lib/components/views/rooms/ReplyPreview'

export default function ReplyPreview(props) {
  return (
    <Fragment>
      <MatrixReplyPreview
        {...props} // eslint-disable-line react/jsx-props-no-spreading
      />
    </Fragment>
  )
}
